<template>
  <custom-section source="Landing/Logos"/>
</template>

<script>
  import iamcLogo from '../../assets/iamc_logo.png';
  import iiasaLogo from '../../assets/iiasa_logo.png';
  import CustomSection from './CustomSection';

  export default {
    name: 'Logos',
    components: {CustomSection},
    data() {
      return {iamcLogo, iiasaLogo};
    },
  };
</script>
